import { ChangeEventHandler, useMemo, useState } from 'react';

import { useUpdateVenueMutation } from '@admin/mutations/VenuesMutations';

import { useAppSettingsQuery } from '@queries/AppQueries';
import { FeedEvent, UserEventRsvp, useCurrentUserEventRsvpsQuery } from '@queries/EventQueries';
import { Series, useSeriesByTagId } from '@queries/TagQueries';
import { SuperAdminVenue, useCityVenuesQuery } from '@queries/VenueQueries';

import { useRsvpToEventMutation, useUpdateEventMutation } from '@mutations/EventMutations';

import { Input } from '@components/form/Input';
import { Select } from '@components/form/Select';
import { Toggle } from '@components/form/Toggle';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

const EventItem = ({
  event,
  options = [],
  onUpdate,
}: {
  event: FeedEvent;
  options: { value: string; label: string }[];
  onUpdate: () => void;
}) => {
  const [value, setValue] = useState(Object.keys((event as any)?.referralUrls ?? {})?.[0]);
  const { updateEventAsync } = useUpdateEventMutation({ eventId: event._id });
  const selectOptions = useMemo(() => {
    return [{ value: '', label: '--' }, ...options];
  }, [options]);

  const onChange: ChangeEventHandler<HTMLSelectElement> = async (e) => {
    const updatedValue = e.target.value;
    setValue(updatedValue);

    await updateEventAsync({
      referralUrls: {
        [updatedValue]: true,
      },
    });

    onUpdate();
  };

  return (
    <div>
      <div className="d-flex gap-2 align-items-center justify-content-between">
        <div>
          <div>
            <strong>{event.title}</strong>
          </div>
          <div style={{ fontSize: '.8rem', opacity: 0.8 }}>
            <div>{event.start}</div>
            <div>{event.venue?.title}</div>
          </div>
        </div>
        <div>
          <Select value={value} options={selectOptions} onChange={onChange} />
        </div>
      </div>
    </div>
  );
};

export const ExistingEventsReferrerList = ({
  events,
  referrerOptions,
}: {
  events: FeedEvent[];
  referrerOptions: { value: string; label: string }[];
}) => {
  return (
    <>
      <div className="d-grid gap-2">
        {events.map((event) => (
          <EventItem key={event._id} event={event} options={referrerOptions} onUpdate={() => {}} />
        ))}
      </div>
    </>
  );
};
